<template>
  <div>
    <div class="p-2   mt-2">
      <div class="flex space-x-2 mb-2 flex-1 items-center">
        <button class="global-button" @click="addFileButton = !addFileButton">
          Yeni Dosya
        </button>
        <select
          v-if="addFileButton"
          class="border flex-1 uk-select p-2"
          v-model="fileCat"
        >
          <option value="0">Dosya için kategori seçiniz</option>
          <option
            v-for="option in this.$root.cache.getOptions[108]"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>

      <file-pond
        v-if="fileCat > 0 && addFileButton"
        :credits="false"
        name="filepond"
        ref="pond"
        :label-idle="
          'Yüklemek istediğiniz (' +
            $root.getVal(108, fileCat) +
            ') dosyalarını buraya sürükleyip bırakınız..'
        "
        v-bind:allow-multiple="true"
        accepted-file-types="image/jpeg, image/png,image/jpg"
        v-bind:files="myFiles"
        v-on:init="handleFilePondInit"
        :server="server"
      />
    </div>

    <div v-if="loading == false">
      <div v-if="files.length > 0">
        <label class="p-2 mt-2 block">Yüklenmiş Dosyalar</label>

        <table
          class="
        uk-table
        journal-table
        uk-table-hover
        heightoverflow
        uk-table-middle uk-table-divider
      "
        >
          <tr>
            <th>DOSYA ADI</th>
            <th>OLUŞTURAN</th>
            <th>KATEGORİ</th>
            <th>OLUŞTURULMA TARİHİ</th>
          </tr>
          <tr v-for="dlead in files">
            <td>
              <a
                target="_blank"
                :href="
                  'https://cdn.viqqa.com/' +
                    config.appName +
                    '/' +
                    id +
                    '/' +
                    dlead.file_name
                "
              >
                <img
                  class="w-20"
                  :src="
                    'https://cdn.viqqa.com/' +
                      config.appName +
                      '/' +
                      id +
                      '/' +
                      dlead.file_name
                  "
              /></a>
            </td>
            <td>{{ $root.getVal(15, dlead.agent_id) }}</td>
            <td>{{ $root.getVal(108, dlead.file_category_id) }}</td>
            <td>{{ dlead.created_at }}</td>
          </tr>
        </table>
      </div>
      <div v-else class="flex items-center justify-center flex-col ">
        <svg
          width="260"
          height="140"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m133.329 126.22 19.262-12.104c2.052-1.284 3.32-3.509 3.343-5.895l.254-24.706a6.803 6.803 0 0 0-3.225-5.856l-19.018-11.741c-2.247-1.388-5.124-1.374-7.405.044l-19.262 12.105c-2.052 1.284-3.32 3.509-3.343 5.895l-.254 24.706a6.803 6.803 0 0 0 3.225 5.856l10.223 6.316 8.799 5.432c2.248 1.388 5.12 1.367 7.394-.047l.007-.005Z"
            stroke="#E16741"
            stroke-width="0.75"
            stroke-miterlimit="10"
          ></path>
          <path
            opacity="0.4"
            d="m145.174 84.733-13.064 8.13c-1.567.95-3.557.958-5.091.007l-8.179-5.051-1.769-1.092-3.362-2.074-3.095-1.913a1.516 1.516 0 0 1-.733-1.328c.003-.26.082-.915.756-1.338l9.51-5.98-.005.022 7.145-4.491c1.546-.968 3.555-.977 5.089-.026l15.103 9.331h-.029l1.286.789c.671.415.736 1.114.739 1.4-.001.28-.08.982-.766 1.401l-3.556 2.226.021-.013Z"
            stroke="#E16741"
            stroke-width="0.75"
            stroke-miterlimit="10"
          ></path>
          <g filter="url(#a)">
            <rect
              x="96"
              y="48.941"
              width="48"
              height="48"
              rx="9"
              transform="rotate(-45 96 48.941)"
              stroke="#E16741"
              stroke-width="0.75"
            ></rect>
          </g>
          <rect
            opacity="0.4"
            x="103.071"
            y="48.941"
            width="38"
            height="38"
            rx="6"
            transform="rotate(-45 103.071 48.941)"
            stroke="#E16741"
            stroke-width="0.75"
          ></rect>
          <path
            d="M123 46.52v3.68c0 1.68 0 2.52.327 3.162a3.004 3.004 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327h4.728c1.372 0 2.057 0 2.6-.22a3.002 3.002 0 0 0 1.652-1.652c.22-.543.22-1.228.22-2.6v-1.805c0-1.68 0-2.52-.327-3.162a3.004 3.004 0 0 0-1.311-1.31c-.642-.328-1.482-.328-3.162-.328h-2.427c-.288 0-.432 0-.573-.02a1.979 1.979 0 0 1-.368-.089c-.135-.046-.263-.112-.52-.243h0l-.507-.26h0a4.115 4.115 0 0 0-.351-.17 1.997 1.997 0 0 0-.544-.132c-.096-.009-.194-.009-.39-.009-.949 0-1.424 0-1.807.127a2.502 2.502 0 0 0-1.586 1.585c-.127.384-.127.859-.127 1.808Z"
            stroke="#E16741"
            stroke-width="0.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M137 47h-14"
            stroke="#E16741"
            stroke-width="0.8"
            stroke-linejoin="round"
          ></path>
          <rect
            x="36"
            y="87"
            width="29"
            height="29"
            rx="6"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          ></rect>
          <rect
            width="29"
            height="29"
            rx="6"
            transform="matrix(-1 0 0 1 221.675 87)"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          ></rect>
          <rect
            x="52.62"
            y="54.659"
            width="29.045"
            height="29.045"
            rx="6"
            transform="rotate(15 52.62 54.659)"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          ></rect>
          <rect
            width="29.045"
            height="29.045"
            rx="6"
            transform="scale(-1 1) rotate(15 -310.116 -751.448)"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          ></rect>
          <rect
            x="33"
            y="31.517"
            width="29.045"
            height="29.045"
            rx="6"
            transform="rotate(-15 33 31.517)"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          ></rect>
          <rect
            width="29.045"
            height="29.045"
            rx="6"
            transform="scale(-1 1) rotate(-15 7.362 869.047)"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          ></rect>
          <defs>
            <filter
              id="a"
              x="79.353"
              y="6.353"
              width="101.176"
              height="101.176"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              ></feColorMatrix>
              <feMorphology
                radius="4"
                in="SourceAlpha"
                result="effect1_dropShadow_96_22008"
              ></feMorphology>
              <feOffset dy="8"></feOffset>
              <feGaussianBlur stdDeviation="12"></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0.14902 0 0 0 0 0.427451 0 0 0 0 0.941176 0 0 0 0.08 0"
              ></feColorMatrix>
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_96_22008"
              ></feBlend>
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              ></feColorMatrix>
              <feMorphology
                radius="6"
                in="SourceAlpha"
                result="effect2_dropShadow_96_22008"
              ></feMorphology>
              <feOffset dy="6"></feOffset>
              <feGaussianBlur stdDeviation="6"></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0.14902 0 0 0 0 0.427451 0 0 0 0 0.941176 0 0 0 0.12 0"
              ></feColorMatrix>
              <feBlend
                in2="effect1_dropShadow_96_22008"
                result="effect2_dropShadow_96_22008"
              ></feBlend>
              <feBlend
                in="SourceGraphic"
                in2="effect2_dropShadow_96_22008"
                result="shape"
              ></feBlend>
            </filter>
          </defs>
        </svg>

        <span class="text-lg font-semibold text-black">Dosya bulunamadı</span>
        <span class="text-sm font-light text-gray-400"
          >Yeni Dosya butonuna tıklandıktan sonra kategorisini seçerek
          yükleyebilirsiniz</span
        >
      </div>
    </div>
    <div v-else class="center">
      <vk-spinner ratio="2"></vk-spinner>
    </div>
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

import httpService from "../../../services/http";
import config from "../../../config";
export default {
  data() {
    return {
      duplicatedLeads: [],
      loading: true,
      addFileButton: false,
      config,
      myFiles: [],
      files: [],
      fileCat: 0,
      server: {
        url: config.endpoint + "/upload/" + this.id,
        headers: {
          Authorization: localStorage.authToken
        },
        process: {
          onload: response => {
            this.getFiles();
          },
          ondata: formData => {
            formData.append("fileCat", this.fileCat);
            return formData;
          }
        }
      }
    };
  },
  props: ["id"],
  mounted() {
    this.getFiles();
  },

  methods: {
    getFiles() {
      //table, field, id
      httpService.files(this.id).then(e => {
        this.files = e.data;
        this.loading = false;
        this.myFiles = [];
      });
    },

    handleFilePondInit: function() {
      console.log("FilePond has initialized");

      // FilePond instance methods are available on `this.$refs.pond`
    }
  },
  components: {
    FilePond
  }
};
</script>
<style scoped>
.filepond--credits {
  display: none !important;
}
</style>
